import { useAuth } from "./useAuth";
import { useIsVolunteer } from "./useIsVolunteer";

/** Every volunteer, and anybody given a duty still to come, such as a visiting speaker (`SELF04`) */
export const useOffersMyRota = () => {
    const isVolunteer = useIsVolunteer();
    const { hasDuties } = useAuth();

    return isVolunteer || hasDuties;
};
